import { t } from "i18next";
import moment from "moment";

import { CONSTANTS } from "@constants/index";
import { DateFormats } from "@enums/shared.enum";
import API_SERVICES from "@services/index";
import localSlice from "@slices/local.slice";
import { store } from "@store/index";

import commonUtils from "./common.utils";

export const compareDates = (date: string, tab: string) => {
  const { DATE_FORMATS, RESERVATION_TABS } = CONSTANTS;

  const momentDate = moment(
    date,
    DATE_FORMATS.YEAR_MONTH_DAY_HYPHEN_FORMAT
  ).startOf(DateFormats.Day);
  const today = moment().startOf(DateFormats.Day);
  switch (tab) {
    case RESERVATION_TABS.TODAY:
      return momentDate.isSame(today, DateFormats.Day);
    case RESERVATION_TABS.FUTURE:
      return momentDate.isAfter(today, DateFormats.Day);
    case RESERVATION_TABS.PAST:
      return momentDate.isBefore(today, DateFormats.Day);
    default:
      return false;
  }
};

export const getTabWithBookedDate = (date: string) => {
  const { DATE_FORMATS, RESERVATION_TABS } = CONSTANTS;

  const momentDate = moment(
    date,
    DATE_FORMATS.YEAR_MONTH_DAY_HYPHEN_FORMAT
  ).startOf(DateFormats.Day);
  const today = moment().startOf(DateFormats.Day);

  if (momentDate.isSame(today, DateFormats.Day)) return RESERVATION_TABS.TODAY;
  else if (momentDate.isAfter(today, DateFormats.Day))
    return RESERVATION_TABS.FUTURE;
  else if (momentDate.isBefore(today, DateFormats.Day))
    return RESERVATION_TABS.PAST;
};

export const logout = async (
  closeModal: () => void,
  showToaster: boolean = true
) => {
  await API_SERVICES.USER.LOG_OUT();
  closeModal();
  store.dispatch(localSlice.actions.clearStorage(null));
  if (showToaster) {
    commonUtils.toastService(
      t("logoutSuccessMsg"),
      CONSTANTS.TOAST_TYPE.SUCCESS
    );
  }
};
